<template>
  <div class="terms-page">
    <!-- Header with back navigation -->
    <header class="header">
      <div class="header-content">
        <v-btn
          icon="mdi-arrow-left"
          variant="text"
          color="white"
          @click="goBack"
          class="back-button"
        />
        <img 
          src="/assets/logo-text-only.png" 
          alt="Youngpro Logo" 
          class="logo-text"
          @click="goHome" 
        />
        <div class="spacer"></div>
      </div>
    </header>

    <!-- Main content -->
    <div class="content-container">
      <div class="content">
        <h1 class="page-title">Privacy Policy 개인정보처리방침</h1>
        
        <div class="terms-content">
          <section class="terms-section">
            <p>
              인터루드(이하 "회사")는 개인정보 보호법 및 관계 법령을 준수하며, 이용자의 개인정보를 안전하게 관리하기 위해 다음과 같이 개인정보처리방침을 수립합니다.
            </p>
          </section>

          <section class="terms-section">
            <h2>제1조 개인정보 수집 목적</h2>
            <p>회사는 다음 목적을 위해 개인정보를 처리합니다.</p>
            <ol>
              <li>회원 가입 및 본인 확인, 계정 생성 및 관리</li>
              <li>서비스 제공: 학습 콘텐츠 제공, 라이브 세션 운영, 커뮤니티 운영, 피드백 제공</li>
              <li>결제 및 정기결제 관리, 결제 기록 확인, 환불 처리</li>
              <li>고객 문의 응대, 민원 처리</li>
              <li>서비스 품질 개선, 신규 서비스 개발, 통계 분석</li>
            </ol>
          </section>

          <section class="terms-section">
            <h2>제2조 처리하는 개인정보 항목</h2>
            <p>회사는 서비스 운영을 위해 다음 정보를 수집합니다.</p>
            
            <p><strong>1. 필수 수집 항목</strong></p>
            <ul>
              <li>이메일 주소</li>
              <li>이름</li>
              <li>비밀번호(암호화 저장)</li>
            </ul>

            <p><strong>2. 결제 시 자동 수집 항목</strong></p>
            <p>(국내 결제: Toss Payments)</p>
            <ul>
              <li>결제 승인 정보</li>
              <li>결제 기록</li>
            </ul>

            <p><strong>3. 서비스 이용 과정에서 자동 수집 항목</strong></p>
            <ul>
              <li>접속 IP 주소</li>
              <li>쿠키 정보</li>
              <li>기기 정보</li>
              <li>서비스 이용 기록(학습 활동, 접속 로그 등)</li>
            </ul>
          </section>

          <section class="terms-section">
            <h2>제3조 개인정보 보유 및 이용 기간</h2>
            <p>회사는 법령에서 정한 기간 동안 개인정보를 보유하며, 보유 기간은 다음과 같습니다.</p>
            <ol>
              <li>회원 가입 정보: 회원 탈퇴 즉시 삭제</li>
              <li>결제 기록: 전자상거래법에 따라 5년</li>
              <li>접속 기록(IP 등): 통신비밀보호법에 따라 3개월</li>
              <li>서비스 이용 기록: 목적 달성 시 삭제</li>
            </ol>
          </section>

          <section class="terms-section">
            <h2>제4조 개인정보의 제3자 제공</h2>
            <p>회사는 원칙적으로 개인정보를 외부에 제공하지 않습니다. 단, 다음의 경우 예외로 합니다.</p>
            <ol>
              <li>법령에 따른 요청이 있는 경우</li>
              <li>서비스 제공을 위해 필요한 범위에서 회사가 지정한 결제대행사(Toss Payments)에게 결제 처리 목적의 정보가 제공되는 경우</li>
            </ol>
            <p>
              제공받는 자: Toss Payments<br/>
              제공 항목: 결제 승인 정보 및 결제 관련 정보<br/>
              보유 기간: 전자상거래법에 따른 기간 동안 보관
            </p>
            <p>회사는 카드번호, CVC 등 민감한 결제 정보는 직접 저장하거나 보유하지 않습니다.</p>
          </section>

          <section class="terms-section">
            <h2>제5조 개인정보 파기</h2>
            <p>회사는 개인정보의 보유 기간 경과 또는 처리 목적 달성 시 지체 없이 파기합니다.</p>
            <ol>
              <li>전자적 파일: 복구 불가능한 방식으로 삭제</li>
              <li>문서(서면): 분쇄 또는 소각</li>
            </ol>
          </section>

          <section class="terms-section">
            <h2>제6조 이용자의 권리</h2>
            <p>이용자는 다음 각 호를 요청할 수 있습니다.</p>
            <ol>
              <li>개인정보 열람 및 사본 제공 요청</li>
              <li>개인정보 정정 요청</li>
              <li>개인정보 삭제 요청</li>
              <li>개인정보 처리 정지 요청</li>
            </ol>
            <p>요청은 회사 이메일(info@youngpro.club)로 접수할 수 있으며, 회사는 법령에 따라 지체 없이 조치합니다.</p>
          </section>

          <section class="terms-section">
            <h2>제7조 개인정보 보호를 위한 안전성 확보 조치</h2>
            <p>회사는 개인정보를 안전하게 관리하기 위해 다음과 같은 조치를 취합니다.</p>
            <ol>
              <li>관리적 조치: 접근 권한 관리, 내부관리계획 수립</li>
              <li>기술적 조치: 암호화 저장, 보안 솔루션 적용, SSL 적용</li>
              <li>물리적 조치: 서버 접근 통제</li>
            </ol>
            <p>결제정보는 Toss Payments의 보안 시스템에 따라 안전하게 처리됩니다.</p>
          </section>

          <section class="terms-section">
            <h2>제8조 쿠키의 이용</h2>
            <p>
              회사는 서비스 향상을 위하여 쿠키를 사용할 수 있습니다.
              이용자는 브라우저 설정을 통해 쿠키 저장 거부가 가능하지만, 일부 서비스 이용이 제한될 수 있습니다.
            </p>
          </section>

          <section class="terms-section">
            <h2>제9조 개인정보 보호책임자</h2>
            <p>개인정보 보호책임자: info@youngpro.club</p>
          </section>

          <section class="terms-section">
            <h2>제10조 개인정보처리방침 변경</h2>
            <p>본 방침은 법령 개정 또는 서비스 정책 변경 시 사전 공지 후 적용됩니다.</p>
          </section>
        </div>

        <div class="last-updated">
          <p>시행일자: 2025년 10월 1일</p>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <FooterDefault current-page="privacy" />
  </div>
</template>

<script>
import FooterDefault from '@/components/FooterDefault.vue';

export default {
  name: 'PrivacyPolicy',
  components: {
    FooterDefault
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    goHome() {
      this.$router.push('/');
    },
    goToTerms() {
      this.$router.push('/terms-of-service');
    },
    goToRefundPolicy() {
      this.$router.push('/refund-policy');
    }
  }
};
</script>

<style scoped>
.terms-page {
  background-color: var(--bg);
  color: var(--text-primary);
  height: 100vh;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  -webkit-scrollbar: none;
}

@media (max-width: 700px) {
  .terms-page {
    max-height: 92vh; /* fallback */
  max-height: calc(100dvh - 6vh); /* URL-bar-safe (see HomePage) */
  }
}

.header {
  height: 6vh;
  width: 100%;
  background-color: var(--bg);
  border-bottom: 1px solid var(--hairline);
  padding: 0 20px;
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-content {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
}

.back-button {
  flex-shrink: 0;
}

.logo-text {
  height: 24px;
  cursor: pointer;
  margin: 0 auto;
}

.spacer {
  width: 40px;
  flex-shrink: 0;
}

.content-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
  min-height: calc(100vh - 6vh);
}

.page-title {
  font-size: 36px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 40px;
  color: var(--text-primary);
}

.terms-content {
  margin-bottom: 40px;
}

.terms-section {
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 1px solid var(--hairline);
}

.terms-section:last-child {
  border-bottom: none;
}

.terms-section h2 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 16px;
  color: var(--accent-strong);
}

.terms-section p {
  font-size: 16px;
  line-height: 1.6;
  color: var(--text-tertiary);
  margin-bottom: 12px;
}

.terms-section ol {
  padding-left: 20px;
  margin: 12px 0;
}

.terms-section ul {
  padding-left: 20px;
  margin: 12px 0;
}

.terms-section li {
  font-size: 16px;
  line-height: 1.6;
  color: var(--text-tertiary);
  margin-bottom: 8px;
}

.last-updated {
  text-align: center;
}

.last-updated p {
  font-size: 14px;
  color: var(--text-tertiary);
}
</style>
